import { Button } from 'uikit';

import type React from 'react';

import type { ITableLikeTreeItem } from '../context';
import { TableLikeTreeContext } from '../context';

import Style from './HierarchyColumnHeader.module.css';

interface IHierarchyColumnHeader {
    showExpandAllSwitch?: boolean;
    title: string | React.ReactNode;
    leftSide?: React.ReactNode;
    rightSide?: React.ReactNode;
    showClearNotifications?: boolean;
    showCreateNewObjectButton?: boolean;
    onAddChildExternallyCall?: (
        addChild: (child: ITableLikeTreeItem, parent?: ITableLikeTreeItem) => any,
        parent?: ITableLikeTreeItem,
    ) => any;
}

export const HierarchyColumnHeader: React.FC<IHierarchyColumnHeader> = (props) => {
    const {
        leftSide,
        rightSide,
        title,
        showExpandAllSwitch,
        showClearNotifications,
        showCreateNewObjectButton,
        onAddChildExternallyCall,
    } = props;

    return (
        <TableLikeTreeContext.Consumer>
            {({ switchExpandAll, areAllExpanded, informers, onInformersClose, addChild }) => (
                <div className={`${Style.hierarchyColumnHeader} ${!rightSide ? 'minContent' : ''}`}>
                    {leftSide}
                    {title}
                    {showCreateNewObjectButton && (
                        <Button
                            label="Создать новый объект"
                            onClick={() => (onAddChildExternallyCall ? onAddChildExternallyCall(addChild) : undefined)}
                            view="secondary"
                            size="s"
                        />
                    )}
                    {showExpandAllSwitch && (
                        <div
                            className={
                                leftSide || title || showCreateNewObjectButton
                                    ? Style.hierarchyColumnHeaderExpandButtons
                                    : undefined
                            }
                        >
                            <Button
                                label="Развернуть все"
                                onClick={() => switchExpandAll(true)}
                                view="clear"
                                disabled={areAllExpanded}
                                size="s"
                            />
                            <Button
                                label="Свернуть все"
                                onClick={() => switchExpandAll(false)}
                                view="clear"
                                disabled={!areAllExpanded}
                                size="s"
                            />
                        </div>
                    )}
                    {showClearNotifications && (
                        <Button
                            label="Убрать сообщения"
                            onClick={onInformersClose}
                            view="clear"
                            disabled={!informers?.length}
                        />
                    )}
                    {rightSide}
                </div>
            )}
        </TableLikeTreeContext.Consumer>
    );
};

HierarchyColumnHeader.displayName = 'HierarchyColumnHeader';
